const introPageContent = [
  {
    "content": "Assuranceski.com API",
    "type": "title"
  },
  {
    "content": "Getting started",
    "type": "subtitle"
  },
  {
    "type": "separator"
  },
  {
    "type": "text",
    "content": "Assuranceski.com REST API enables you to integrate the purchase of ski insurance via Assuranceski.com directly into your ski pass purchase flow.\n\nThe purpose of this API is twofold:<ul><li>to make your online insurance sales path compliant with European laws</li><li>to facilitate the integration of future regulatory changes, the pace of which are increasing every year</li></ul>"
  },
  {
    "type": "semi_title",
    "content": "URL and test environment:\n"
  },
  {
    "type": "subtitle",
    "content": "There are two environments - SANDBOX and LIVE - each with its own base url"
  },
  {
    "type": "text",
    "content": "Sandbox: <code>assuranceski-api-sandbox.web.app</code>\n"
  },
  {
    "type": "text",
    "content": "<b>LIVE: <code>assuranceski-api.web.app</code></b>\n"
  },
  {
    "type": "separator"
  },
  {
    "type": "subtitle",
    "content": "Regarding access to the API please fill our onboarding form <a href=\"https://airtable.com/shr8t4cPYIu8Inawo\" target=\"_blank\">airtable.com/shr8t4cPYIu8Inawo</a>"
  },
  {
    "type": "subtitle",
    "content": "For any questions and issues connected to API usage please fill in the following form <a href=\"https://airtable.com/shrb3lPFAF6aQmh86\" target=\"_blank\">airtable.com/shrb3lPFAF6aQmh86</a>"
  }
]

export default introPageContent
